import { render, staticRenderFns } from "./InstanceGroupDetails.vue?vue&type=template&id=d00a7724&scoped=true&"
import script from "./InstanceGroupDetails.vue?vue&type=script&lang=ts&"
export * from "./InstanceGroupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a7724",
  null
  
)

export default component.exports